<template>
  <base-section
  id="call-for-papers-orange"
  space="0"
  >
    <v-container>
    <base-section-heading
    title="Call for Papers"
    align="left"
    :toColor="true"
    >
    Click <a
    href="LATS25_cfp.pdf"
    download
    >here</a> to download our Call for Papers and find all the latest information in one document.
    <br />
    <br />
    <v-btn
        href="LATS25_cfp.pdf"
        rounded
        color="primary"
        dark
        download
        style="padding: 15px"
    >
        <v-icon
        left
        dark
        >
        mdi-cloud-download
        </v-icon>
        Call for Papers
        </v-btn>
    </base-section-heading>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'CallForPapersOrange',

    data: () => ({
      features: [
        {
          title: 'Pixel Perfect Design',
          icon: 'mdi-fountain-pen-tip',
        },
        {
          title: 'Retina Ready',
          icon: 'mdi-cellphone',
        },
        {
          color: 'primary',
          dark: true,
          title: 'Easily Customizable',
          icon: 'mdi-pencil-box-outline',
        },
        {
          title: 'Image Parallax',
          icon: 'mdi-image-size-select-actual',
        },
        {
          title: 'Seo Optimized',
          icon: 'mdi-ice-pop',
        },
        {
          title: '24/7 Support',
          icon: 'mdi-help-circle-outline',
        },
      ],
    }),
  }
</script>

<style>
.v-application .grey--text.text--darken-1 {
  color: black !important;
}
.v-application .grey--text.text--lighten-1 {
  color: white !important;
}
</style>
